import D2C_HostCloud from './Cloud'

class D2C_HostGCP extends D2C_HostCloud {
  static objectType = 'hostType'
  static active = true
  static providerType = 'GCP'
  static color = '#00aa44'
  static minExtraStorage = 10
  static maxExtraStorage = 16000
  static fields = {
    ...D2C_HostCloud.fields,
    labels: {
      ...D2C_HostCloud.fields.labels,
      width: 12,
    },
    backup: {
      default: false,
      label: 'Backup',
      path: 'backup',
      required: false,
      width: 4,
      enum: [
        {value: true, text: 'ON'},
        {value: false, text: 'OFF'},
      ],
      validate() {
        return null
      },
      creating: {},
    },
    extraStorage: {
      default: 0,
      infoHeader: 'Zonal Persistent disks',
      infoLine1: 'Additional storage for instances by Google.',
      infoLine2: 'You have to restart the host when you change it.',
      label: 'Size',
      path: 'extraStorage',
      required: false,
      width: 4,
      validate(value) {
        return value && value < 10 ? 'Must be more than 10' : null
      },
      updating: {},
    },
    instance: {
      ...D2C_HostCloud.fields.instance,
      reversible: true,
      reversibleReadonly: true,
    },
  }
  static stats = {
    ...D2C_HostCloud,
    ebs_disk: {},
  }
}

export default D2C_HostGCP
